import './assets/form-control.css';
import { jsx as t } from "react/jsx-runtime";
import c from "clsx";
const l = "_form_control_8a1kx_3", m = {
  form_control: l
}, e = (o) => {
  const { className: r, children: n } = o;
  return /* @__PURE__ */ t(
    "div",
    {
      style: {
        gridColumn: o.colSpan ? `span ${o.colSpan}` : void 0
      },
      className: c(m.form_control, r),
      children: n
    }
  );
};
export {
  e as FormControl
};
